import React from 'react'
import st from './TotalStatistic.module.scss'
import { formatDuration } from '../CallAnalytics'

const TotalStatistic = ({
  totalIncomingCalls,
  totalOutgoingDuration,
  totalIncomingDuration,
  totalOutgoingCalls,
  totalDuration,
  sortBy,
  translate,
}) => {
  return (
    <div className={st.statistic}>
      <div className={st.statisticHeader}>
        <h3>{translate?.total}</h3>
      </div>
      <div className={st.statisticType}>
        <div>{translate?.incoming}</div>
        <div className={st.verticalSeparator}></div>
        <div>{translate?.outgoing}</div>
      </div>
      <div className={st.callInfo}>
        <div className={st.progressBarAndTotal}>
          <div className={st.progressBar}>
            <div
              className={st.incomingBar}
              style={{
                width: `${(totalIncomingCalls / (totalIncomingCalls + totalOutgoingCalls)) * 100}%`,
              }}
            >
              {sortBy === 'quantity'
                ? totalIncomingCalls
                : formatDuration(totalIncomingDuration)}
            </div>
            <div
              className={st.outgoingBar}
              style={{
                width: `${(totalOutgoingCalls / (totalIncomingCalls + totalOutgoingCalls)) * 100}%`,
              }}
            >
              {sortBy === 'quantity'
                ? totalOutgoingCalls
                : formatDuration(totalOutgoingDuration)}
            </div>
          </div>
          <div className={st.totalCalls}>
            {sortBy === 'quantity'
              ? totalIncomingCalls + totalOutgoingCalls
              : formatDuration(totalDuration)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TotalStatistic
